import { useRef, useState } from "react";
import { fileUrl } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { toPng } from "html-to-image";
import { Download, ShieldCheck, User, Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function Badge({ data }) {
  const ref = useRef(null);
  const [downloading, setDownloading] = useState(false);
  if (!data) return null;
  const photo = fileUrl(data.photo_path);

  const download = async () => {
    if (!ref.current) return;
    setDownloading(true);
    try {
      const url = await toPng(ref.current, { pixelRatio: 3, cacheBust: true });
      const a = document.createElement("a");
      a.href = url; a.download = `carnet_${data.name.replace(/\s+/g, "_")}.png`; a.click();
      toast.success("Carnet descargado");
    } catch (e) {
      toast.error("No se pudo descargar el carnet");
    } finally { setDownloading(false); }
  };

  return (
    <div className="flex flex-col items-center gap-4">
      <div
        ref={ref}
        data-testid="employee-badge"
        className="w-[320px] rounded-2xl overflow-hidden bg-white shadow-xl border border-slate-200"
        style={{ fontFamily: "'Manrope', sans-serif" }}
      >
        <div className="h-24 relative flex items-center justify-between px-5" style={{ background: data.company_color }}>
          <div className="flex items-center gap-2 text-white">
            {data.company_logo ? (
              <img src={data.company_logo} alt="" crossOrigin="anonymous" className="h-8 w-8 rounded-md object-cover bg-white/20" />
            ) : <ShieldCheck className="h-6 w-6" />}
            <span className="font-bold text-sm leading-tight" style={{ fontFamily: "'Outfit', sans-serif" }}>{data.company_name}</span>
          </div>
          <span className="text-[10px] font-bold tracking-[0.15em] uppercase text-white/80">Fichando</span>
        </div>

        <div className="px-5 pb-5 -mt-10">
          <div className="h-24 w-24 rounded-2xl border-4 border-white shadow-md overflow-hidden bg-slate-100 flex items-center justify-center mx-auto">
            {photo ? (
              <img src={photo} alt={data.name} crossOrigin="anonymous" className="h-full w-full object-cover" />
            ) : <User className="h-10 w-10 text-slate-300" />}
          </div>
          <div className="text-center mt-3">
            <div className="font-bold text-lg text-slate-900" style={{ fontFamily: "'Outfit', sans-serif" }}>{data.name}</div>
            <div className="text-sm font-medium" style={{ color: data.company_color }}>{data.position}</div>
            <div className="text-xs text-slate-400 mt-0.5">{data.department}</div>
          </div>

          <div className="mt-4 flex items-center justify-between bg-slate-50 rounded-xl p-3">
            <div className="text-[11px] leading-tight">
              <div className="text-slate-400 uppercase tracking-wider font-bold text-[9px]">Código</div>
              <div className="font-mono font-semibold text-slate-700">{data.employee_code}</div>
              <div className="text-slate-400 uppercase tracking-wider font-bold text-[9px] mt-1.5">Alta</div>
              <div className="font-semibold text-slate-700">{data.hire_date || "—"}</div>
            </div>
            <img src={data.qr} alt="QR verificación" className="h-20 w-20 rounded-lg bg-white" />
          </div>
        </div>
      </div>

      <Button onClick={download} disabled={downloading} className="brand-btn" data-testid="download-badge-btn">
        {downloading ? <Loader2 className="h-4 w-4 animate-spin" /> : <><Download className="h-4 w-4 mr-2" /> Descargar carnet</>}
      </Button>
    </div>
  );
}
